/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsfieldsalesendhint4Inputs */

const en_ticketsfieldsalesendhint4 = /** @type {(inputs: Ticketsfieldsalesendhint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From this moment nobody can get this ticket type. Leave it empty to sell until the event ends.`)
};

const de_ticketsfieldsalesendhint4 = /** @type {(inputs: Ticketsfieldsalesendhint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ab diesem Zeitpunkt kann niemand mehr diese Ticketart bekommen. Leer lassen verkauft bis zum Ende des Events.`)
};

/**
* | output |
* | --- |
* | "From this moment nobody can get this ticket type. Leave it empty to sell until the event ends." |
*
* @param {Ticketsfieldsalesendhint4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsfieldsalesendhint4 = /** @type {((inputs?: Ticketsfieldsalesendhint4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsfieldsalesendhint4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsfieldsalesendhint4(inputs)
	return de_ticketsfieldsalesendhint4(inputs)
});
export { ticketsfieldsalesendhint4 as "ticketsFieldSalesEndHint" }